import { Pill } from "@src/appV2/redesign/system/ui-components";

export function ShiftForYouPill() {
  return (
    <Pill
      size="small"
      variant="filled"
      label="For You"
      iconType="star-filled"
      sx={(theme) => ({
        width: "fit-content",
        backgroundColor: theme.palette.intent?.success.background,
        color: theme.palette.intent?.success.text,
      })}
    />
  );
}
